import { render, staticRenderFns } from "./TikTok.vue?vue&type=template&id=6bae73d6&"
import script from "./TikTok.vue?vue&type=script&lang=ts&"
export * from "./TikTok.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports